export const VEHICLE_BRAND_ROUTE_PREFIX = "/settings/vehicle-brands";

export const VEHICLE_BRAND_ROUTE_PATHS = {
  brands: { path: "*", to: VEHICLE_BRAND_ROUTE_PREFIX },
  models: { path: ":id/vehicle-models", to: `${VEHICLE_BRAND_ROUTE_PREFIX}/:id/vehicle-models` },
};
